import { DataDictionaryView } from '@types';

import { ApiEndpointHandler, createGetEndpoint } from '@sonar-software/sonar-http';

export type GetDataDictionaryViewRequest = {
	id: number;
};

export type GetDataDictionaryViewResponse = Omit<DataDictionaryView, 'id' | 'name'> & {
	viewId: number;
	viewName: string;
};

const getDataDictionaryViewBase = createGetEndpoint<GetDataDictionaryViewRequest, GetDataDictionaryViewResponse>(
	({ id }) => `/api/v3/data-dictionary/views/${id}`
);

export const getDataDictionaryView: ApiEndpointHandler<
	GetDataDictionaryViewRequest,
	GetDataDictionaryViewResponse
> = async(request, options) => {
	const response = await getDataDictionaryViewBase(request, options);

	if (response.data) {
		response.data.columns = atob(response.data.columns ?? '');
	}

	return response;
};
